import styled from '@emotion/styled';
import { getLanguageLabelByCode } from '@hotjar/feedback/domain/Surveys/Wizard/Wizard';
import { useTranslation } from '@hotjar/translations';
import { tokens } from '@hotjar/hotsauce';

interface AppearanceSummaryProps {
  languageCode: string;
  backgroundColor: string;
  buttonColor: string;
}

const ColorPreview = styled.div<{ color: string }>`
  border: 1px solid ${tokens.color.ui_border};
  height: ${tokens.spacer.x2};
  width: ${tokens.spacer.x2};
  background-color: ${({ color }) => color};
  display: inline-block;
  margin-bottom: -2px;
`;

export const AppearanceSummary = ({
  languageCode,
  backgroundColor,
  buttonColor,
}: AppearanceSummaryProps): JSX.Element => {
  const { t } = useTranslation('feedback', { keyPrefix: 'wizard.section.appearance.summary' });
  return (
    <div>
      {getLanguageLabelByCode(languageCode)}
      {', '}
      {t('background')}
      {': '}
      <ColorPreview color={backgroundColor} />
      {', '}
      {t('button')}
      {': '}
      <ColorPreview color={buttonColor} />
    </div>
  );
};
